import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import BreadcrumbNav from '../common/BreadcrumbNav/index.js';
import {HomeOutlined} from '@ant-design/icons';

function SpecialistDoctorNav() {
    const {locale} = useRouter();
    
    return (
        <div>
            <BreadcrumbNav
                items={[
                    {label: '', href: '/', icon: <HomeOutlined />},
                    {label: getLocaleContent(locale, 'page.specialist-doctor.breadcrumb-title'), href: '/chuyen-gia-bac-si', color: '#006940'},
                ]}
            />
        </div>
    );
}

export default SpecialistDoctorNav;
